var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-list"},[_c('h2',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.operationStatus == 1 ? '导入记录' : '导出记录')+" ")]),_c('div',{staticClass:"list_wrap"},[_c('bk-list',{ref:"list",attrs:{"table-config":_vm.tableConfig}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }